import http from "./http-common";

class RefrenceTypeService {  
  async getAll() {    
   const respons= await http.get(`RefrenceType/GetByLanguageId`);    
    return respons
  }  
}

export default new RefrenceTypeService();